/**
 * Created by jerome on 09/10/2018.
 */
import SVGShape from './SVGShape'
export const MINX = 0
export const MINY = 1
export const MAXX = 2
export const MAXY = 3
export default class SVGPathDatas {
  constructor () {
    this._shapes = []
    this._current = new SVGShape()
    this._bounds = false
  }

  get bounds () { return this._bounds }

  get shapes () { return this._shapes }

  getShape (index) { return this._shapes[index] }

  svgPath (rounded) {
    let svg = ''
    this._shapes.forEach(s => { svg += s.toSVG(rounded) })

    return svg
  }

  // start a shape group
  // startGroup() { console.log('startGroup');this.shapes = []; }

  // start a new shape in the group
  startShape () {
    // console.log('startShape')
    this._current = new SVGShape()
  }

  // add an on-screen point
  addPoint (x, y) {
    this._current.addPoint(x, y)
    let _bounds = this._bounds
    if (!_bounds) { _bounds = this._bounds = [x, y, x, y] }
    if (x < _bounds[MINX]) { _bounds[MINX] = x }
    if (x > _bounds[MAXX]) { _bounds[MAXX] = x }
    if (y < _bounds[MINY]) { _bounds[MINY] = y }
    if (y > _bounds[MAXY]) { _bounds[MAXY] = y }
  }

  resetBounds () {
    this._bounds = false
  }

  updatePoint (pt, x, y) {
    pt.x = x
    pt.y = y
    let _bounds = this._bounds
    if (!_bounds) { this._bounds = [x, y, x, y] }
    if (x < this._bounds[MINX]) { this._bounds[MINX] = x }
    if (x > this._bounds[MAXX]) { this._bounds[MAXX] = x }
    if (y < this._bounds[MINY]) { this._bounds[MINY] = y }
    if (y > this._bounds[MAXY]) { this._bounds[MAXY] = y }
  }

  // set the x/y coordinates for the left/right control points
  setLeftControl (x, y) {
    this._current.setLeft(x, y)
  }

  setRightControl (x, y) {
    this._current.setRight(x, y)
  }

  // close the current shape
  closeShape () {
    // console.log('closeShape')
    this._shapes.push(this._current)
    this._current = null
  }

  // close the group of shapes.
  /* closeGroup(){
   console.log('closeGroup');
   this.shapes.push(this.current);
   this.current=null; } */
}
